export { default } from './OpenInAI.view'
